import React from 'react';
import { Link, ListItem } from '@mui/material';
import { Heading3, Paragraph, UnorderedList, LegalCard } from './LegalComponents';

export const PrivacyPolicyPage = () => {
  return (
    <LegalCard title="Datenschutzbestimmungen">
      <Paragraph>
        Die vorliegende Datenschutzerklärung der Alloy Ads, als Produkt der Ringier AG, (nachfolgend «wir» oder «Alloy
        Ads») informiert die Kunden und Nutzer (nachfolgend «Sie» oder «Nutzer») unserer Dienstleistungen, Angebote und
        Produkte (nachfolgend «Dienste») über die Beschaffung und die Bearbeitung Ihrer Daten (Personendaten als auch
        nicht personenbezogene Daten; nachfolgend «Daten»).
      </Paragraph>
      <Heading3>1. Einführung</Heading3>
      <Paragraph>
        Im Folgenden informieren wir Sie unter anderem darüber, wer für die Bearbeitung Ihrer Daten verantwortlich ist,
        welche Daten wir im Zusammenhang mit Ihrer Nutzung unserer Dienste erheben, für welche Zwecke wir diese Daten
        bearbeiten sowie wem wir diese Daten gegebenenfalls weitergeben. Weiter informieren wir Sie über die Dauer der
        Bearbeitung Ihrer Daten, die Rechtsgrundlage der Bearbeitung (sofern eine solche notwendig sein sollte) sowie
        darüber, welche Rechte Ihnen im Hinblick auf die Bearbeitung Ihrer Daten uns gegenüberzustehen. Diese
        Datenschutzerklärung gilt für alle Ihre Daten, die uns bereits vorliegen oder die uns in Zukunft vorliegen
        werden. Bitte beachten Sie, dass wir die Datenschutzerklärung von Zeit zu Zeit anpassen können. Es gilt die
        jeweils aktuelle, auf{' '}
        <Link href="https://app.alloyads.ai/privacy-policy" target="_blank">
          https://app.alloyads.ai/privacy-policy
        </Link>
        . publizierte Fassung.
      </Paragraph>
      <Paragraph>
        Als Personendaten gelten alle Angaben, die sich auf eine bestimmte oder bestimmbare Person beziehen (nachfolgend
        «Personendaten»). Darunter fallen insbesondere Informationen wie Name, Adresse, Telefonnummer, E-Mail-Adresse,
        unter Umständen auch IP-Adressen und Geräte IDs. Unter den Oberbegriff Daten fallen in der vorliegenden
        Datenschutzerklärung neben den Personendaten auch nicht personenbezogene und anonymisierte Daten. Unter
        Bearbeitung versteht man jeden Umgang mit Daten, unabhängig von den angewandten Mitteln und Verfahren,
        insbesondere das Erheben, Speichern, Nutzen, Umarbeiten, Bekanntgeben, Archivieren oder Löschen von Daten
        (nachfolgend «Bearbeiten»). Wenn Sie uns Personendaten anderer Personen zur Verfügung stellen, stellen Sie bitte
        sicher, dass diese Personen diese Datenschutzerklärung kennen und teilen Sie uns deren Personendaten nur mit,
        wenn Sie gemäss geltendem Datenschutzrecht dazu berechtigt sind.
      </Paragraph>
      <Heading3>2. Verantwortliche</Heading3>
      <Paragraph>
        Verantwortlich für die Datenbearbeitungen gemäss dieser Datenschutzerklärung ist die Ringier AG in Argau,
        Schweiz. Für Anliegen und Anfragen im Zusammenhang mit dem Datenschutz wenden Sie sich bitte an unsere
        Fachstelle Datenschutz (erreichbar via{' '}
        <Link href="mailto:datenschutz@ringier.ch" target="_blank" rel="nofollow">
          datenschutz@ringier.ch
        </Link>
        ).
      </Paragraph>
      <Heading3>3. Kategorien der bearbeiteten Daten</Heading3>
      <Paragraph>
        Bei der Nutzung unserer Dienste und im Kontakt mit der Alloy Ads (z.B. beim Besuch unserer Webseiten, bei der
        Verwendung eines unserer digitalen Dienste, beim Vertragsabschluss, bei der Registrierung und bei der Anmeldung
        im Alloy Ads-Portal, oder im Kontakt mit unseren Mitarbeitenden) erheben wir bestimmte Daten. Grundsätzlich
        erheben wir diese Daten von Ihnen direkt. In bestimmten Fällen kann es vor-kommen, dass wir Daten von anderen
        Personen erhalten (z.B., wenn Ihr Arbeitgeber uns Ihre Kontaktangaben angibt oder wenn ein Unternehmen, mit dem
        Sie eine Vertragsbeziehung unterhalten, uns Ihre Daten weiterleitet).
      </Paragraph>
      <Paragraph>Zu den Personendaten, die wir bearbeiten, können die folgenden Daten gehören:</Paragraph>
      <UnorderedList>
        <ListItem disableGutters>
          Daten, welche uns bei der Registrierung für einen unserer Dienste bekannt gegeben werden (z.B. Namen,
          Kontaktdaten, Geschlecht, Berufsbezeichnung, Mitarbeitende, Sprache, Zahlungsinformationen, Zugangsdaten,
          Informationen zu Werbung, Opt-ins und Opt-outs, etc.).
        </ListItem>
        <ListItem disableGutters>
          Daten betreffend Offerten und abgeschlossene Verträge (z.B. Vertragsdatum, -art, -inhalt, -produkt, -parteien,
          -laufzeit, -wert, -anpassungen, Details zur Zahlung, Kontaktdaten, Ansprechpersonen, Rechnungs- und
          Korrespondenzadressen, Kundenfeed-back, Kündigungen, Streitigkeiten, etc.).
        </ListItem>
        <ListItem disableGutters>
          Daten, welche bei der Verwendung unserer Dienste durch registrierte und nicht registrierte Nutzer ermittelt
          oder bekanntgegeben werden. Dazu zählen unter anderem die IP- und MAC-Adresse bzw. Device-ID des verwendeten
          Geräts, Cookies, von Nutzern aufgerufene Seiten und eingegebene Suchbegriffe, Eingaben Dialogfelder, Zeitpunkt
          und Dauer der Besuche, Klicks, Reaktionen auf Angebote von der Alloy Ads und Dritten, Referent/Exit-URL,
          Angaben zum Zeitpunkt der Verwendung, zum Browser- und Gerätetyp sowie verwendeten Betriebssystem und Internet
          Service Provider, übertragene Daten-menge). Dazu gehören auch Daten, welche über unsere Dienste (inkl.
          allfällig eingebundener Drittdienste) veröffentlicht oder bekanntgeben werden (z.B. Bilder, Texte, Videos,
          Banner etc.). Wir können Personendaten aus einem unserer Dienste mit Daten aus ei-nem anderen Dienst
          zusammenführen.
        </ListItem>
        <ListItem disableGutters>
          Daten, welche im oder in Bezug auf den Kontakt mit uns ausgetauscht werden (z.B. Kommunikation per Brief,
          Telefon, Telefax, E-Mail, Text- und Bildnachrichten (SMS/MMS), Videonachrichten oder Instant Messaging,
          Reaktionen auf Kommunikation und Angebote von der Alloy Ads, bevorzugte Kommunikationskanäle, etc.).
        </ListItem>
        <ListItem disableGutters>
          Gewisse Dienste können bei aktivierter Geolocation-Funktion des verwendeten Gerätes standortbezogene Daten
          erheben und speichern.
        </ListItem>
        <ListItem disableGutters>
          Daten, die uns Dritte, mit denen wir Geschäftsbeziehungen unterhalten, zur Verfügung stellen (z.B.
          Verzeichniseinträge, Adressdatenbanken, Mutationen von Datenbankeinträgen, Bonitätsdaten, Angaben von
          unternehmensinternen Kontaktpersonen, etc.).
        </ListItem>
        <ListItem disableGutters>
          Daten aus öffentlichen Quellen (z.B. Handelsregistereinträge, andere Verzeichnisse, etc.).
        </ListItem>
      </UnorderedList>
      <Paragraph>
        Obige Daten stellen nicht in jedem Fall Personendaten dar. In der Regel können wir Daten, welche bei der
        Verwendung unserer Dienste ohne Registrierung (z.B. mittels eines Nutzerkontos) anfallen, keiner namentlich
        individualisierten Person zuordnen. In Einzelfällen kann dies jedoch in Kombination mit weiteren Daten möglich
        sein.
      </Paragraph>
      <Paragraph>
        Zur Nutzung unserer Dienste werden Sie unter Umständen bestimmte Personendaten bereitstellen müssen, die für die
        Aufnahme und Abwicklung der Vertragsbeziehung und Erfüllung der damit verbundenen vertraglichen Pflichten
        notwendig oder rechtlich vorgeschrieben sind. Ohne diese Personendaten werden wir in der Regel nicht in der Lage
        sein, den Vertrag zu schliessen und diesen auszuführen oder einen bestimmten Dienst zu erbringen. Notwendig ist
        auch die Protokollierung der Zugriffe auf unsere digitalen Dienste und die da-mit verbundene Erhebung der
        Verbindungsdaten (wie z.B. die IP-Adresse); diese erfolgt automatisch bei der Benutzung und lässt sich nicht für
        einzelne Nutzer abstellen. Wenn Sie also mit der Erhebung solcher Daten nicht einverstanden sind, sollten Sie
        auf die Nutzung unserer Dienste verzichten.
      </Paragraph>
      <Heading3>4. Bearbeitungszwecke und Rechtsgrundlagen</Heading3>
      <Paragraph>
        Wir werden Personendaten, soweit nach anwendbarem Recht zulässig, insbesondere für die folgenden Zwecke
        bearbeiten:
      </Paragraph>
      <UnorderedList>
        <ListItem disableGutters>Anbahnung, Abschluss, Erfüllung und Abwicklung von Verträgen;</ListItem>
        <ListItem disableGutters>
          Angebot, Weiterentwicklung und Verbesserung unserer Dienste, Neuentwicklung von Diensten, Betrieb, Wartung,
          Optimierung und Gewährleistung der Sicherheit unserer Dienste und Infrastruktur;
        </ListItem>
        <ListItem disableGutters>
          Verwaltung der Nutzer unserer Dienste, Identitätsprüfungen, Log-ins, und sonstige Authentifizierungen;
        </ListItem>
        <ListItem disableGutters>
          Pflege, Administration und Entwicklung unserer Kundenbeziehungen, Kommunikation mit Kunden und Dritten,
          Kundendienst und Support, Promotionen, Werbung und Marketing, Erstellen von Nutzerprofilen, Angebot von
          massgeschneiderten Diensten und relevanten Inhalten;
        </ListItem>
        <ListItem disableGutters>
          Schutz der Nutzer, unserer Mitarbeitenden und Dritter sowie Schutz unserer Daten, Geheimnisse und
          Vermögenswerte, Sicherheit unserer Systeme, Gebäude und übriger Infrastruktur;
        </ListItem>
        <ListItem disableGutters>
          Qualitätskontrolle, Marktforschung, Erstellen von Statistiken, Berichten und Managementinformationen,
          Geschäftsführung und Entwicklung des Unternehmens, unseres Angebotes und unserer Aktivitäten;
        </ListItem>
        <ListItem disableGutters>
          Einhaltung rechtlicher und regulatorischer Verpflichtungen und interner Regeln, Rechtsdurchsetzung, Zivil-,
          Verwaltungs- und Strafverfahren, Beschwerden, Missbrauchsbekämpfung, Untersuchungen und Beantwortung von
          Anfragen von Behörden und Amts-stellen.
        </ListItem>
        <ListItem disableGutters>
          Wir können darüber hinaus Personendaten auch für weitere Zwecke bearbeiten, sofern eine rechtliche Pflicht die
          Bearbeitung erfordert oder wir an anderer Stelle darüber informieren bzw. die Bearbeitung zum Zeitpunkt der
          Datenerhebung aus den Umständen erkennbar war.
        </ListItem>
      </UnorderedList>
      <Paragraph>
        Wir verwenden die Personendaten für obige Zwecke auf Basis der folgenden Rechtsgrund-lagen, soweit eine solche
        unter dem anwendbaren Datenschutzrecht erforderlich ist:
      </Paragraph>
      <UnorderedList>
        <ListItem disableGutters>Vertragserfüllung</ListItem>
        <ListItem disableGutters>Erfüllung rechtlicher Verpflichtungen;</ListItem>
        <ListItem disableGutters>Einwilligung, die uns oder Dritten gegenüber erteilt wurde;</ListItem>
        <ListItem disableGutters>Berechtigte Interessen von uns und von Dritten, insbesondere:</ListItem>
        <UnorderedList sx={{ pt: 0 }}>
          <ListItem disableGutters>Angebot und Erbringen von Diensten;</ListItem>
          <ListItem disableGutters>Werbung und Marketing;</ListItem>
          <ListItem disableGutters>Kontaktpflege und Kommunikation mit Nutzern und Dritten;</ListItem>
          <ListItem disableGutters>
            Nachvollziehen von Nutzerverhalten, -vorlieben und -bedürfnissen, Marktstudien;
          </ListItem>
          <ListItem disableGutters>
            Weiterentwicklung und Verbesserung unserer Dienste, Entwicklung neuer Dienste;
          </ListItem>
          <ListItem disableGutters>Nutzerverwaltung, Identitätsprüfungen, Log-ins, Authentifizierungen;</ListItem>
          <ListItem disableGutters>
            Schutz der Nutzer, unserer Mitarbeitenden und Dritter, unserer Daten, Geheimnisse, Infrastruktur und
            Vermögenswerte;
          </ListItem>
          <ListItem disableGutters>
            Aufrechterhaltung und sichere, effiziente und effektive Organisation des Geschäftsbetriebs, einschliesslich
            eines sicheren, effizienten und effektiven Betriebs und erfolgreiche Weiterentwicklung der digitalen Dienste
            und anderer IT-Systeme, Fehlerbehebung;
          </ListItem>
          <ListItem disableGutters>
            Sinnvolle Unternehmensführung und -entwicklung, erfolgreicher Verkauf oder Kauf von Geschäftsbereichen,
            Gesellschaften oder Teilen von Gesellschaften und andere gesellschaftsrechtliche Transaktionen;
          </ListItem>
          <ListItem disableGutters>
            Einhaltung rechtlicher und regulatorischer Verpflichtungen und interner Regeln, Rechtsdurchsetzung, Zivil-,
            Verwaltungs- und Strafverfahren, Beschwerden, Missbrauchsbekämpfung, Untersuchungen und Beantwortung von
            Anfragen von Behörden.
          </ListItem>
        </UnorderedList>
      </UnorderedList>
      <Heading3>5. Veröffentlichung und Weitergabe von Daten</Heading3>
      <Paragraph>Wir können Daten wie folgt veröffentlichen und weitergeben:</Paragraph>
      <UnorderedList>
        <ListItem disableGutters>
          <strong>Veröffentlichung von Daten</strong>
          <Paragraph>
            Bestimmte unserer Dienste sehen die Veröffentlichung von Daten vor. Veröffentlichte Daten können in der
            Regel überall, auch ausserhalb der Schweiz, abgerufen werden. Beispielsweise die Vorschau der Werbemittel im
            Creative Generator. Auch mittels entsprechender Funktionen unserer Dienste veröffentlichte Daten (z.B.
            Posts, Bilder, Texte, Videos, Banner, etc.) können der Öffentlichkeit zugänglich sein. Daten, die über
            unsere Dienste veröffentlicht werden, werden möglicherweise auch von Suchmaschinen (wie z.B. Google)
            indexiert oder von Dritten weiterverbreitet, worauf wir keinen Einfluss haben; somit können solche Daten
            auch weiterhin öffentlich in jedem Land der Erde verfügbar sein, nachdem diese gegebenenfalls bei uns
            gelöscht wurden.
          </Paragraph>
        </ListItem>
        <ListItem disableGutters>
          <strong>Auftragsdatenbearbeiter</strong>
          <Paragraph>
            Wir können Dritte mit der Erbringung bestimmter Leistungen (z.B. im Bereich IT, Betrieb von Anwendungen,
            Administration, Druck, Versand, etc.) und mit der Bearbeitung und Speicherung von Daten beauftragen (sog.
            «Auftragsdatenbearbeiter»). Auftragsdatenbearbeiter können Zugang zu Personendaten haben und diese in
            unserem Auftrag be-arbeiten. Dabei verpflichten wir die Auftragsbearbeiter, das Datenschutzrecht einzuhalten
            und Daten nur so zu bearbeiten, wie wir dies selbst tun. Auftragsdatenbearbeiter, die Personendaten erhalten
            können, können sich in beliebigen Ländern befinden, insbesondere in der Schweiz, in Ländern der EU und des
            EWR und in den USA.
          </Paragraph>
        </ListItem>
        <ListItem disableGutters>
          <strong>Vertragspartner</strong>
          <Paragraph>
            Wir können Daten an Vertragspartner (beispielsweise Vertriebspartner, Dienstleister, Kunden, Lieferanten,
            Finanzunternehmen, etc.) weitergeben. Das geschieht beispielsweise für die Erfüllung vertraglicher
            Verpflichtungen, für das Angebot bestimmter Diens-te, für den Abgleich, die Validierung und Aktualisierung
            von Datenbanken (einschliesslich von zentralen Adress- und Kontaktdatenverzeichnissen von uns und von
            unseren Vertragspartnern), für Inkasso- und Marketingzwecke, für die Analyse der Nutzung und den Betrieb
            unserer Dienste, Systeme und Infrastruktur und für die Zahlungsabwicklung. Mögliche Empfänger können auch
            Erwerber oder Interessenten am Erwerb von Geschäftsbereichen, Gesellschaften oder Teilen davon sein.
            Vertragspartner können Zugang zu Personendaten erhalten und diese für eigene Zwecke (beispielweise für die
            Vertragserfüllung oder die Erfüllung eigener rechtlicher Verpflichtungen) bearbeiten. Sie sind dabei selbst
            verpflichtet, anwendbare Datenschutzgesetze einzuhalten. Vertrags-partner, die Personendaten erhalten
            können, können sich in beliebigen Ländern befinden, insbesondere in der Schweiz, in Ländern der EU und des
            EWR und in den USA.
          </Paragraph>
        </ListItem>
        <ListItem disableGutters>
          <strong>Weitergaben an Behörden und andere Weitergaben aus rechtlichen Gründen</strong>
          <Paragraph>
            In gewissen Situationen können wir Daten an Behörden, Amtsstellen und andere Dritte offenlegen (z.B. in
            Zusammenhang mit behördlichen oder amtlichen Anfragen, Untersuchungen und Abklärungen,
            Administrativuntersuchungen, Strafuntersuchungen, Zivil- und/oder Strafverfahren). Wir tun dies in Fällen,
            wo wir dazu behördlich oder amtlich aufgefordert werden oder nach unserer Beurteilung verpflichtet sind oder
            wo wir nach Treu und Glauben davon ausgehen dürfen, dass der Zugriff auf die betreffenden Daten oder ihre
            Nutzung, Aufbewahrung oder Weitergabe vernünftigerweise notwendig ist, um geltende Nutzungsbedingungen
            durchzusetzen, Betrug oder Sicherheitsmängel aufzudecken, zu verhindern oder zu bekämpfen oder die Rechte
            und das Eigentum von der Alloy Ads zu schützen.
          </Paragraph>
        </ListItem>
      </UnorderedList>
      <Paragraph>
        Werden Daten, die nicht ohnehin öffentlich sind, in ein Land ohne angemessenen Datenschutz übermittelt, so
        gewährleisten wir einen angemessenen Datenschutz durch Einsatz hinreichender vertraglicher Garantien, so
        namentlich auf Basis der EU-Standardvertragsklauseln, Binding Corporate Rules, oder wir stützen uns auf die
        Ausnahme der Einwilligung, der Vertragsabwicklung, der Feststellung, Ausübung oder Durchsetzung von
        Rechtsansprüchen, überwiegender öffentlicher Interessen oder weil es zum Schutz der Unversehrtheit einer
        betroffenen Person nötig ist. Wo das anwendbare Datenschutzrecht dies vorsieht, können Sie in Bezug auf Ihre
        Personendaten bei unserer Fachstelle Datenschutz eine Kopie der vertraglichen Garantien beziehen oder in
        Erfahrung bringen, wo eine solche Kopie eingeholt werden kann. Wir behalten uns vor, solche Kopien aus
        datenschutzrechtlichen Gründen oder aus Geheimhaltungsgründen zu schwärzen.
      </Paragraph>
      <Heading3>6. Aufbewahrungsdauer</Heading3>
      <Paragraph>
        Wir speichern Personendaten, solange das für den Zweck, für den wir sie erhoben haben, erforderlich ist.
        Bestimmte Personendaten unterliegen zudem rechtlich verbindlichen Aufbewahrungspflichten von zehn oder mehr
        Jahren, die wir berücksichtigen. Wir können Personendaten auch mindestens für die Dauer der anwendbaren
        Verjährungsfristen speichern, die in vielen Fällen fünf oder zehn Jahre beträgt. Personendaten, die im
        Zusammenhang mit der Nutzung unserer Dienste anfallen (z.B. Protokolle, Logs, Analysen, etc.) und die keinen
        solchen Aufbewahrungs- oder Verjährungsfristen unterliegen, löschen wir in der Regel früher, sobald wir kein
        Interesse mehr an der Bearbeitung haben. Daten können in anonymisierter Form jeweils auch länger aufbewahrt
        werden. Unter Vorbehalt einer ausdrücklichen vertraglichen Vereinbarung sind wir Ihnen gegenüber nicht
        verpflichtet, Daten für eine be-stimmte Dauer aufzubewahren.
      </Paragraph>
      <Heading3>7. Cookies, Webanalyse- und Trackingtools sowie andere Technologien</Heading3>
      <Paragraph>
        Wir verwenden verschiedene gängige Technologien, um Daten zu erfassen, zu speichern und auszuwerten, wenn Sie
        unsere Dienste nutzen.
      </Paragraph>
      <Paragraph>
        Hierzu gehören insbesondere Cookies, mit denen Ihr Browser oder Ihr Gerät identifiziert werden kann. Ein Cookie
        ist eine kleine Datei, die an Ihren Computer gesendet bzw. vom verwendeten Webbrowser automatisch auf Ihrem
        Computer oder mobilen Gerät gespeichert wird, wenn Sie einen unserer Dienste aufrufen. Wenn Sie einen Dienst
        erneut aufrufen, kann dieser Ihren Browser oder Ihr Gerät mithilfe des Cookies wiedererkennen. Cookies können
        Nutzereinstellungen und andere Informationen speichern. Neben sog. Session-Cookies, welche nach einem Besuch
        unserer Dienste automatisch wieder gelöscht werden, setzen wir auch temporäre und permanente Cookies ein, welche
        länger auf ihrem Computer oder mobilen Gerät gespeichert bleiben. Die eingesetzten Cookies dienen in erster
        Linie dazu, Ihnen die Funktionalitäten der verschiedenen Dienste komfortabel und sicher anzubieten (so bspw. das
        Einloggen ins Nutzerkonto).
      </Paragraph>
      <Paragraph>
        Zudem ermöglichen uns die mittels Cookies erhobenen Informationen, unsere Dienste den Kundenwünschen
        entsprechend zu verbessern sowie Ihnen auf Sie zugeschnittenen Angebote und Werbung zu unterbreiten. Wir gehen
        davon aus, dass der Nutzer mit der Nutzung unserer Dienste und der entsprechenden Funktionen (z.B. Sprachwahl,
        Auto Log-in) in den Einsatz solcher Cookies einwilligt. Sie können die Verwendung von Cookies in ihren
        Browsereinstellungen sperren oder diese dort löschen. Bitte beachten Sie, dass bei einer Nichtzulassung von
        Cookies gegebenenfalls nicht sämtliche Funktionen eines Dienstes vollumfänglich genutzt werden können, und dass
        bei einer Löschung der Cookies allfällig von Ihnen gesetzte Opt-out-Cookies auch gelöscht werden. Solche Optout
        Cookies müssten dann bei einem erneuten Besuch des entsprechenden Dienstes wieder aktiviert werden. Ansonsten
        werden Sie als neuer Benutzer erkannt und Ihre Daten werden wieder erfasst.
      </Paragraph>
      <Paragraph>
        Neben Cookies können wir auch andere Technologien (z.B. Pixel, Web-Beacons, Tags, Werbe-IDs) einsetzen, um die
        Nutzung unserer Dienste zu analysieren, unsere Dienste zu personalisieren und um auf Sie zugeschnittene Angebote
        und Werbung anzuzeigen. Beim Versand von Newslettern und E-Mails beispielsweise können wir Technologien
        einsetzen, die uns erlauben zu analysieren, welche Inhalte für Nutzer interessant sind und ob, wann und wie sie
        auf unsere Angebote reagieren (z.B. durch Herunterladen von Bildern in einer E-Mail, Klicks auf URLs in einer
        E-Mail oder auf einer Website, Ausfüllen von Formulardaten, etc.). Wir gehen davon aus, dass der Nutzer mit der
        Nutzung solcher Funktionen in den Einsatz entsprechender Technologien einwilligt.
      </Paragraph>
      <Paragraph>
        Schliesslich setzen wir verschiedene gängige Webanalyse- und Trackingtools ein, um die Nutzung unserer Dienste
        zu messen und auszuwerten. Solche Tools, die meist von Dritten zur Verfügung gestellt werden, stellen uns
        Informationen und Statistiken über die Nutzung unserer Dienste zur Verfügung, die uns dabei helfen, die Nutzung
        unserer Dienste besser zu verstehen und entsprechend den Nutzerbedürfnissen anzupassen.
      </Paragraph>
      <Paragraph>
        Beispielsweise verwenden wir Google Analytics, einen Webanalysedienst der Google LLC. Google Analytics verwendet
        dabei ebenfalls Cookies. Die durch das Cookie erzeugten Informationen über Ihre Nutzung unserer Dienste werden
        in der Regel an einen Server von Google in den USA übertragen und dort gespeichert. Auf unseren Diensten wurde
        für Google Analytics die IP-Anonymisierung aktiviert. Ihre IP-Adresse wird damit von Google innerhalb von
        Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des EWR zuvor gekürzt. Nur in
        Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt.
        Google wird diese Informationen benutzen, um die Nutzung der entsprechenden Website auszuwerten, um Reports über
        die Websiteaktivitäten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung
        verbundene Dienstleistungen gegenüber dem Websitebetreiber zu erbringen. Weitere Informationen zu den
        eingesetzten Webanalyse- und Trackingtools sowie zu allenfalls bestehenden Möglichkeiten, deren Verwendung zu
        deaktivieren bzw. blockieren, finden Sie unter{' '}
        <Link href="https://alloyads.ai" target="_blank" rel="nofollow">
          alloyads.ai
        </Link>
        .
      </Paragraph>
      <Paragraph>
        Bitte beachten Sie, dass auf unseren Diensten auch ausgewählte Dritte (z.B. Werbepart-ner), Cookies und andere
        Technologien einsetzen können, um die Nutzung der Dienste zu analysieren, die Dienste zu personalisieren und um
        auf Sie zugeschnittene Angebote und Werbung anzuzeigen. Eine Übersicht über die Dritten, mit denen wir in diesem
        Bereich zusammenarbeiten, finden Sie unter{' '}
        <Link href="https://alloyads.ai" target="_blank" rel="nofollow">
          alloyads.ai
        </Link>
        . Für die Datenbearbeitungen dieser Dritten gelten deren Nutzungs- und Datenschutzbestimmungen.
      </Paragraph>
      <Heading3>8. Social Media Plugins und weitere Einbindungen von Angeboten Dritter</Heading3>
      <Paragraph>
        Wir binden Plugins sozialer Netzwerke (z.B. Facebook, Google Plus, Twitter) in unsere Dienste ein. Durch diese
        Plugins wird das Teilen von Inhalten auf diesen Plattformen erleichtert. Eine Übersicht der eingesetzten Plugins
        finden Sie unter{' '}
        <Link href="https://alloyads.ai" target="_blank" rel="nofollow">
          alloyads.ai
        </Link>
        .
      </Paragraph>
      <Paragraph>
        Beim Besuch unserer Dienste, die solche Plugins enthalten, kann automatisch eine Verbindung zum Server des
        jeweiligen Anbieters hergestellt werden. Dabei werden gewisse Daten (wie z.B. Zeitpunkt des Besuchs des
        Dienstes, Browsertyp, IP-Adresse) von diesem er-fasst und gespeichert. Habe Sie bei einem dieser Anbieter ein
        Benutzerkonto, kann dieser diese Informationen Ihrem Profil zuordnen. Interagieren Sie zusätzlich mit diesen
        Plugins (z.B. durch Anklicken des «Gefällt-mir»- Buttons oder durch Abgabe eines Kommentars) werden auch diese
        Informationen an diesen Anbieter übermittelt, dort gespeichert und gegebenenfalls veröffentlicht. Bei der
        Verwendung eines Social Login-Services (z.B. Facebook-Connect), kann uns der Anbieter Personendaten wie
        beispielsweise Name, E-Mail-Adresse und Profilbild, die bei ihm über Sie hinterlegt sind, übermitteln.
      </Paragraph>
      <Paragraph>
        Weiter binden wir Dienstleistungen von Dritten auf unseren Diensten ein, die es Ihnen ermöglichen, mit Kunden
        und anderen Nutzern von der Alloy Ads sowie Dritten zu interagieren (so z.B. über einen Buchungsservice eine
        Reservation zu tätigen oder Bewertungen und Kommentare abzugeben). Dazu werden allfällig angegebene Daten an
        diese Dritte zur Bearbeitung und Ausführung der entsprechenden Dienstleistung weitergeleitet bzw. direkt bei
        diesen bearbeitet.
      </Paragraph>
      <Paragraph>
        Bitte beachten Sie, dass für die Datenbearbeitungen dieser Dritten deren Nutzungs- und Datenschutzbestimmungen
        gelten.
      </Paragraph>
      <Heading3>9. Rechte betroffener Personen</Heading3>
      <Paragraph>
        Jede betroffene Person hat ein Auskunftsrecht über sie betreffende Personendaten. Zudem hat sie das Recht, von
        uns die Berichtigung, Löschung und Einschränkung von sie betreffenden Personendaten zu verlangen sowie einer
        solchen Bearbeitung von Personendaten zu widersprechen. Die Ausübung solcher Rechte setzt in der Regel voraus,
        dass die betroffene Person ihre Identität eindeutig nachweisen kann. Falls die Bearbeitung der Personendaten auf
        einer Einwilligung beruht, kann die Einwilligung durch die betroffene Person jederzeit widerrufen werden. In
        Staaten der EU bzw. dem EWR hat die betroffene Person in gewissen Fällen das Recht, die bei der Nutzung von
        Online-Diensten generierten Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten,
        welches die weitere Nutzung und Übermittlung ermöglichen. Anfragen im Zusammenhang mit diesen Rechten sind an
        die Fachstelle Datenschutz (siehe oben Ziff. 2) zu richten. Wir behalten uns vor, die Rechte der betroffenen
        Person im Rahmen des jeweils anwendbaren Rechts einzuschränken und z.B. keine vollständige Auskunft zu erteilen
        oder Daten nicht zu löschen.
      </Paragraph>
      <Paragraph>
        Wir machen Sie zudem darauf aufmerksam, dass durch eine Löschung Ihrer Personendaten Dienste ganz oder teilweise
        nicht mehr zur Verfügung stehen bzw. genutzt werden können.
      </Paragraph>
      <Paragraph>
        Wenn wir automatisiert eine einzelne Person betreffende Entscheidung vornehmen, die gegenüber der betroffenen
        Person rechtliche Wirkungen entfaltet oder sie in ähnlicher Weise erheblich beeinträchtigt, kann die betroffene
        Person bei uns mit einer zuständigen Person sprechen und von ihr eine Wiedererwägung des Entscheids verlangen,
        oder von vornherein die Beurteilung durch eine Person verlangen, soweit das anwendbare Recht dies vorsieht. In
        diesem Fall kann die betroffene Person gewisse automatisierte Dienstleistungen unter Umständen nicht mehr
        nutzen. Die Person wird über solche Entscheide nachfolgend oder separat vorgängig informiert.
      </Paragraph>
      <Paragraph>
        Jede betroffene Person hat das Recht, bei der zuständigen Datenschutzbehörde eine Beschwerde einzureichen. Im
        Falle eines Verantwortlichen in der Schweiz ist dies der Eidgenössische Datenschutz- und
        Öffentlichkeitsbeauftragte (
        <Link href="https://www.edoeb.admin.ch" target="_blank" rel="nofollow">
          https://www.edoeb.admin.ch
        </Link>
        ).
      </Paragraph>
      <Heading3>Ringier AG, May 2025</Heading3>
    </LegalCard>
  );
};
